document.addEventListener("DOMContentLoaded", function(event) {
  const aboutSwiper = new Swiper('.swiper-product-about', {
    direction: 'horizontal',
    slidesPerView: 1.2,
    spaceBetween: 28,

    grabCursor: true,
    freeMode: false,
    slideToClickedSlide: true,

    loop: false,
    mousewheel: {
      forceToAxis: true
    },
    scrollbar: {
      el: '.swiper-scrollbar',
    },
    breakpoints: {
      750: {
        slidesPerView: 3.2,
      }
    },
  });

  const slideoutSwiper = new Swiper('.swiper-slideout', {
    direction: 'horizontal',
    slidesPerView: 1,
    spaceBetween: 0,
    grabCursor: true,
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  });


  $('.mobile-collapsed__heading').on('click', function () {
    var $parentEl = $(this).closest('.mobile-collapsed');
    $parentEl.find('.mobile-collapsed__inner').slideToggle();
    $parentEl.toggleClass('expanded-content');
  });

});
